<div class="wrapper">
    	<app-admin-header [pageTitle]="tenantName" [pageSubTitle]="tenantSubName"></app-admin-header>
    <div class="queries-container">
        <!-- <div class="queries-left">
            <h2>Your Queries</h2>
            <div class="query-card" *ngFor="let q of queries">
                <div class="query-header">
                    <h3>{{ q.title }}</h3>
                    <div class="tags">
                        <span class="priority" [ngClass]="q.priority.toLowerCase()">{{ q.priority }}</span>
                        <span class="status" [ngClass]="q.status.toLowerCase().replace(' ', '-')">{{ q.status }}</span>
                    </div>
                </div>
                <p>{{ q.description }}</p>
                <p class="date">Created on {{ q.date }}</p>
            </div>
        </div> -->
        <div class="queries-right">
            <h2>Submit New Query</h2>
			<form [formGroup]="createQueryForm">

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Subject</mat-label>
                <input matInput formControlName="subject" placeholder="Brief description of your issue" />
				 <mat-error *ngIf="createQueryForm.controls['subject'].invalid && createQueryForm.controls['subject'].touched"
				  class="text-danger smaller-text">Subject is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Priority</mat-label>
                <mat-select formControlName="priority">
                    <mat-option [value]="adminQueryPriority.LOW">Low</mat-option>
                    <mat-option [value]="adminQueryPriority.MEDIUM">Medium</mat-option>
                    <mat-option [value]="adminQueryPriority.HIGH">High</mat-option>
                </mat-select>

				<mat-error *ngIf="createQueryForm.controls['priority'].invalid && createQueryForm.controls['priority'].touched"
				class="text-danger smaller-text">Priority is required</mat-error>
               </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Description</mat-label>
                <textarea matInput formControlName ="description"
                placeholder="Provide detailed information about your query..." rows="4"></textarea>

				<mat-error *ngIf="createQueryForm.controls['description'].invalid && createQueryForm.controls['description'].touched"
				class="text-danger smaller-text">Description is required</mat-error>
				</mat-form-field>
			</form>

            <button class="btn-add w-100" (click)="submitQuery()">
				<ng-container *ngIf="isLoading; else noLoading">
                  <span class="spinner-border spinner-border-sm"></span> Creating...</ng-container>
		    <ng-template #noLoading> Submit Query</ng-template>
            </button>
        </div>
    </div>
</div>